"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCurrencyTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _accounting = _interopRequireDefault(require("accounting"));
var _external = require("../external");
var _Flag = require("../Flag");
var _Status = require("../Status");
var _StyledTable = require("./StyledTable.styles");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledCurrencyTable = function StyledCurrencyTable(props) {
  var currencyPairData = props.currencyPairData,
    selectedCurrencyPairs = props.selectedCurrencyPairs,
    currencyPairOnClick = props.currencyPairOnClick,
    testId = props.testId,
    fundingOptions = props.fundingOptions;
  var classes = (0, _StyledTable.useStyles)({
    funding: fundingOptions && true
  });
  return /*#__PURE__*/_react["default"].createElement(_external.Table, {
    "data-testid": testId,
    className: (0, _clsx["default"])(classes.table, props.className)
  }, /*#__PURE__*/_react["default"].createElement(_external.TableHead, null, /*#__PURE__*/_react["default"].createElement(_external.TableRow, null, /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, "Currency"), /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, "Amount"), /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
    className: "paymentTitle",
    align: "right"
  }, "Payments"), fundingOptions && /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, "Method"))), /*#__PURE__*/_react["default"].createElement(_external.TableBody, null, currencyPairData.map(function (currencyPair, i) {
    var selected = (selectedCurrencyPairs === null || selectedCurrencyPairs === void 0 ? void 0 : selectedCurrencyPairs.filter(function (selectedPair) {
      return (selectedPair === null || selectedPair === void 0 ? void 0 : selectedPair.sellCurrency) === currencyPair.sellCurrency && (selectedPair === null || selectedPair === void 0 ? void 0 : selectedPair.buyCurrency) === currencyPair.buyCurrency;
    }).length) > 0;
    var sameCurrencyPayment = currencyPair.sellCurrency === currencyPair.buyCurrency;
    var fundingOption = fundingOptions === null || fundingOptions === void 0 ? void 0 : fundingOptions.filter(function (fundingOption) {
      return fundingOption.sellCurrency === currencyPair.sellCurrency && fundingOption.buyCurrency === currencyPair.buyCurrency;
    })[0];
    var funded = false;
    if (fundingOption) {
      funded = fundingOption.amount === parseFloat(fundingOption.fundedAmount);
    }
    return /*#__PURE__*/_react["default"].createElement(_external.TableRow, {
      key: i,
      className: (0, _classnames["default"])(classes.clickable, _defineProperty({}, classes.selected, selected)),
      onClick: function onClick() {
        return currencyPairOnClick(currencyPair);
      }
    }, /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      className: "currencyFlag"
    }, sameCurrencyPayment ? /*#__PURE__*/_react["default"].createElement(_Flag.Flag, {
      size: "md",
      code: currencyPair.sellCurrency
    }) : /*#__PURE__*/_react["default"].createElement(_Flag.DualFlag, {
      startFlag: {
        code: currencyPair.sellCurrency,
        size: 'md'
      },
      endFlag: {
        code: currencyPair.buyCurrency,
        size: 'md'
      },
      arrowHeight: 11,
      arrowWidth: 10,
      arrowColor: "LIGHT"
    })), /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      className: "currencyAmount"
    }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", null, currencyPair.buyCurrency), ' ', /*#__PURE__*/_react["default"].createElement("span", null, "".concat(_accounting["default"].format(currencyPair.amount, 2))))), /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      className: "currencyPayments",
      align: "right"
    }, currencyPair.noOfPayments), fundingOptions && /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, funded ? /*#__PURE__*/_react["default"].createElement(_Status.Status, {
      variant: "success"
    }, "Funded") : /*#__PURE__*/_react["default"].createElement(_Status.Status, null, "Unfunded")));
  })));
};
exports.StyledCurrencyTable = StyledCurrencyTable;